import React from 'react';
import {PictureUsage} from './AddPicturesButton';
import {
  AssetMetaInterface,
  DesignerSettings,
  AssetService,
} from '@taopix/taopix-core/dist/types/types';
import UploadFromDeviceDialog from './UploadFromDeviceDialog';
import APIServer from '@taopix/taopix-core/dist/types/Service/APIServer';
import PreviousUploadsFactory from './PreviousUploads/PreviousUploadsFactory';

export type InternalAssetServiceProps = {
  isOpen: boolean;
  closeEvent: () => void;
  assetService: AssetService;
  projectImageList: AssetMetaInterface[];
  pictureUsage: PictureUsage;
  assetServices?: AssetService[];
  server: APIServer;
  designerSettings: DesignerSettings;
};

const InternalAssetService = ({
  isOpen,
  closeEvent,
  assetService,
  projectImageList,
  pictureUsage,
  assetServices,
  server,
  designerSettings,
  ...props
}: InternalAssetServiceProps) => {
  return assetService.code === '%PREVIOUSUPLOADS%' ? (
    <PreviousUploadsFactory
      settings={designerSettings}
      server={server}
      usage={pictureUsage}
      projectImages={projectImageList}
    />
  ) : (
    <UploadFromDeviceDialog
      isOpen={false}
      closeEvent={closeEvent}
      assetService={assetService}
      server={server}
      designerSettings={designerSettings}
      projectImageList={projectImageList}
    />
  );
};

export default InternalAssetService;
